import { profitTypes } from 'live/components/index.shared';
import { GameType } from 'live/components/index.types';
import TopListItem from 'live/components/TopListItem';
import PropTypes from 'prop-types';
import React from 'react';

import Alert from 'shared/components/Alert';
import Loader from 'shared/components/loader/Loader';

import styles from './index.module.scss';

const TopList = ({
  error,
  full,
  limit,
  list,
  loading,
  offset = 0,
  showPosition,
  type,
}) => {
  if (loading) {
    return (
      <div className={styles.loading}>
        <Loader visible />
      </div>
    );
  }

  if (error) {
    return <Alert type="error" text={error} />;
  }

  if (!list) {
    return null;
  }

  const listToDisplay = limit
    ? list.slice(0, limit)
    : offset
    ? list.slice(offset, list.length)
    : list;

  return (
    <div>
      {listToDisplay.map((game, i) => (
        <TopListItem
          full={full}
          game={game}
          key={i}
          position={showPosition ? i + 1 : undefined}
          type={type}
        />
      ))}
    </div>
  );
};

TopList.propTypes = {
  error: PropTypes.string,
  full: PropTypes.bool,
  limit: PropTypes.number,
  list: PropTypes.arrayOf(GameType),
  loading: PropTypes.bool,
  offset: PropTypes.number,
  showPosition: PropTypes.bool,
  type: PropTypes.oneOf(profitTypes),
};

export default TopList;
